import { Outlet } from 'react-router-dom';
import { AuthGuard } from '../components/auth/AuthGuard';
import { Layout } from '../components/Layout';

export const ProtectedLayout = () => {
    return (
        <AuthGuard>
            <Layout>
                <Outlet />
            </Layout>
        </AuthGuard>
    );
};
